import { useContext } from "react";
import { InvoicesItemsPageContext } from "./InvoicesItemsPageContext";

export const useInvoicesItemsPage = () => {
  const context = useContext(InvoicesItemsPageContext);
  if (!context) {
    throw new Error(
      "useInvoicesItemsPage must be used within an InvoicesItemsPageProvider"
    );
  }
  return context;
};
